// Webpack Imports
import * as bootstrap from 'bootstrap';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'hover focus',
		} );
	} );

	// Initialize Tab navs: https://getbootstrap.com/docs/5.0/components/navs-tabs
	var triggerTabList = [].slice.call(document.querySelectorAll('#myTab li:last-child a'))
	triggerTabList.forEach(function (triggerEl) {
		var tabTrigger = new bootstrap.Tab(triggerEl)
		triggerEl.addEventListener('click', function (event) {
			event.preventDefault()
			tabTrigger.show()
		})
	})

} )();

//Back to top button
let mybutton = document.getElementById("btn-back-to-top");

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  if (
    document.body.scrollTop > 20 ||
    document.documentElement.scrollTop > 20
  ) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}
// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener("click", backToTop);

function backToTop() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

//Auto hide nav
document.addEventListener("DOMContentLoaded", function(){
	let el_autohide = document.querySelector('.autohide');
	// add padding-top to bady (if necessary)
	let navbar_height = document.querySelector('.navbar').offsetHeight;
	document.body.style.paddingTop = navbar_height + 'px';

	if(el_autohide){
		var last_scroll_top = 0;
		window.addEventListener('scroll', function() {
			let scroll_top = window.scrollY;
			if(scroll_top < last_scroll_top) {
				el_autohide.classList.remove('scrolled-down');
				el_autohide.classList.add('scrolled-up');
			}
			else {
				el_autohide.classList.remove('scrolled-up');
				el_autohide.classList.add('scrolled-down');
			}
			last_scroll_top = scroll_top;
		}); // window.addEventListener
	} // if
}); // DOMContentLoaded end
